import AddLatePayment from './AddLatePayment';
import LatePaymentOrders from './LatePaymentOrders';
import WaitingPayment from './WaitingPayment';

export default function LatePayment() {
    return (
        <>
            <WaitingPayment />
            <LatePaymentOrders />
            <AddLatePayment />
        </>
    );
}
